import React, { useContext, useState, useEffect } from "react";
import { Dialog, Button, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_PLANS } from "../../graphql/queries";
import { planEnv } from "../link";
import { StyledDialogContent, StyledDialogTitle } from "../../assets/css/styledComponent";
import { UserContext } from "../../components/auth/auth-context";
import { getEffectivePlan } from "../utils";

export const UpgradePlan = ({
  featureName,
  requiredPlanId,
  applyExemption = true,
  onClose = (skip) => {},
}) => {
  const { providerUser } = useContext(UserContext);
  const [open, setOpen] = useState(true);
  const { data, loading, error } = useQuery(GET_PLANS, { variables: { planEnv } });

  // Convert requiredPlanId to a number and check validity.
  const required = Number(requiredPlanId);
  const validPlan = required && required !== -1;
 
  const effectivePlan = getEffectivePlan(providerUser) 
  const exempt = (effectivePlan && applyExemption) ? Number(effectivePlan) : null;
 
  const shouldShow = validPlan && (exempt === null || required > exempt);
 
  useEffect(() => {
    if (!shouldShow) {
      onClose(true); // true means "upgrade skipped" so parent can open the next form.
    }
  }, [shouldShow, onClose]);

  // If we shouldn't show the dialog, render nothing.
  if (!shouldShow) return null;

  if (loading)
    return (
      <Dialog open={open} onClose={() => setOpen(false)}>
        Loading...
      </Dialog>
    );
  if (error)
    return (
      <Dialog open={open} onClose={() => setOpen(false)}>
        Error loading plans.
      </Dialog>
    );

  const plan = data?.plans?.find((p) => Number(p.id) === required);

  return (
    <Dialog
      open={open}
      onClose={() => {
        // When the user manually closes the dialog, we signal that upgrade was not skipped.
        onClose(false);
        setOpen(false);
      }}
      maxWidth="sm"
      sx={{
        "& .MuiDialog-paper": {
          width: "360px",
          borderRadius: "8px",
          background: "#ffffff",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
          border: "none",
          p: 3,
        },
      }}
    >
      <StyledDialogTitle
        sx={{
          fontSize: "1.5rem",
          fontWeight: 600,
          mb: 2,
          color: "#212121",
          backgroundColor: "transparent",
          borderBottom: "1px solid #e0e0e0",
          pb: 1,
        }}
      >
        Upgrade Required
      </StyledDialogTitle>
      <StyledDialogContent>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          <strong>{featureName}</strong> feature is available on the{" "}
          <strong>{plan?.name}</strong> plan and above. Please upgrade your plan to access this feature.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Link
            to="/biz/pricing"
            state={{ from: window.location.href }}
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0d47a1",
                color: "#fff",
                borderRadius: "4px",
                textTransform: "none",
                fontWeight: "bold",
                padding: "10px 20px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              }}
            >
              Upgrade Plan
            </Button>
          </Link>
        </Box>
      </StyledDialogContent>
    </Dialog>
  );
};

export default UpgradePlan;
